@if ((federalStates$ | async); as federalStates) {
  @for (federalState of federalStates; track federalState.id) {
    <span>
      {{federalState.attributes.name}}
    </span>
  }
} @else {
  <app-skeleton-text width="60"></app-skeleton-text>
}

